<template>
  <div class="animated revealUp font-weight-bold" style="zoom: 0.7">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ merchandise_id ? $t("edit") : $t("add") }} {{ $t("merchandise") }}
      </div>
      <router-link class="btn-blue" to="merchandise-list"
        >{{ $t("merchandise") }} {{ $tc("list") }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <section class="mb-2">
        <div class="d-flex">
          <div
            class="section-title mb-2 d-flex justify-content-between section-border section-border col-12"
            style="padding: 6px; align-items: center"
            v-b-toggle.merchandise_details
          >
            <span class="fs">Merchandise Details</span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
        </div>

        <b-collapse
          id="merchandise_details"
          v-model="sectionCollapse.merchandise_details"
        >
          <div class="new-border back rounded-10 col-12 pt-3 mb-2">
            <div class="row">
              <div class="col-lg-3 col-xl-2 mb-1">
                <div class="input-material">
                  <input
                    v-model="merchandiseObj.merchandise_name"
                    v-validate="'required'"
                    name="merchandise_name"
                    id="merchandise_name"
                    placeholder="."
                    type="text"
                  />
                  <label>{{ $t("name") }}</label>
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('merchandise_name')">{{
                    errors.first("merchandise_name")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-3 col-xl-2 mb-1">
                <div class="input-material d-flex align-items-center">
                  <input
                    v-model="merchandiseObj.alt_merchandise_name"
                    name="alt_merchandise_name"
                    id="alt_merchandise_name"
                    placeholder="."
                    type="text"
                    v-b-tooltip.hover
                    :title="`Alt. Merchandise Name`"
                  />
                  <label>Alt. Name</label>
                </div>
                <p class="error_message"></p>
              </div>

              <div class="col-lg-3 col-xl-2 mb-1">
                <div class="input-material d-flex align-items-center">
                  <input
                    v-model="merchandiseObj.m_description"
                    name="m_description"
                    id="m_description"
                    placeholder="."
                    type="text"
                    v-b-tooltip.hover
                    :title="`Description`"
                  />
                  <label>Description</label>
                </div>
                <p class="error_message"></p>
              </div>

              <div class="col-lg-3 col-xl-2 mb-1">
                <multiselect
                  :options="Categories"
                  v-model="merchandiseObj.selectedCategory"
                  :searchable="true"
                  :multiple="false"
                  :placeholder="'Category'"
                  label="m_cat_name"
                  track-by="m_cat_id"
                  style="min-width: 210px"
                  @input="onSelectCategory($event, 'select')"
                  @remove="onSelectCategory($event, 'remove')"
                ></multiselect>
                <p class="error_message"></p>
              </div>

              <div class="col-lg-3 col-xl-2 mb-1">
                <multiselect
                  :options="Tags"
                  v-model="merchandiseObj.merch_tags"
                  :multiple="true"
                  :placeholder="'Tags'"
                  label="m_tag_name"
                  track-by="m_tag_id"
                  style="min-width: 210px"
                ></multiselect>
                <p class="error_message"></p>
              </div>

              <div class="col-lg-3 col-xl-1 mb-1" style="min-width: 200px">
                <!-- <label class="mb-0 mr-3">{{ $t("Upload image") }}</label> -->
                <div class="d-flex align-items-center">
                  <button
                    class="fnb-btn-edit"
                    @click.prevent.stop="setModalData(null, null)"
                  >
                    Choose File
                  </button>

                  <label
                    style="display: none"
                    class="material-file-upload"
                    @click.prevent.stop="setModalData(null, null)"
                  >
                  </label>

                  <img
                    width="40"
                    height="40"
                    class="rounded ml-2 mr-2"
                    @click="showImage()"
                    :src="_GetImagePath(merchandiseObj.merchandise_image_url)"
                    v-if="
                      merchandiseObj.hasOwnProperty('merchandise_image_url') &&
                        merchandiseObj.merchandise_image_url
                    "
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded ml-2 mr-2"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>

              <div
                class="col-2 align-self-center mb-1"
                style="padding-bottom: 15px"
              >
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    class="j-checkbox pb-0"
                    v-model="merchandiseObj.is_non_sellable"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span class="ml-1">Non Sellable</span>
                </div>
              </div>
              <div
                class="col-2 align-self-center mb-1"
                style="padding-bottom: 15px"
              >
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    :disabled="merchandise_id ? true : false"
                    class="j-checkbox pb-0"
                    v-model="merchandiseObj.is_combo_pack"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span class="ml-1">Is Combo</span>
                </div>
              </div>
              <div
                class="col-lg-2 col-xl-1 align-self-center mb-1"
                style="padding-bottom: 15px"
              >
                <div class="d-flex align-items-center justify-content-center">
                  <b-form-checkbox
                    class="j-checkbox pb-0"
                    v-model="merchandiseObj.merchandise_is_active"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span class="ml-1">{{
                    merchandiseObj.merchandise_is_active === "Y"
                      ? "Active"
                      : "Deactive"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2" v-if="merchandiseObj.is_combo_pack == 'Y'">
        <div class="d-flex">
          <div
            class="section-title mb-2 d-flex justify-content-between section-border section-border col-12"
            style="padding: 6px; align-items: center"
            v-b-toggle.merchandise_options
          >
            <span class="fs"> {{ $t("merchandise") }} Combo Items</span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
        </div>

        <b-collapse
          id="merchandise_options"
          v-model="sectionCollapse.merchandise_options"
        >
          <div class="new-border back rounded-10 col-12 pt-3 mb-2">
            <div class="row">
              <div class="col-12" style="margin-left: 1px">
                <div
                  v-for="(optionObj, optionIndex) in merchandiseObj[
                    'combo_pack'
                  ]"
                  :key="optionIndex"
                  class="mb-2"
                >
                  <div class="row">
                    <div class="col-3">
                      <div class="">
                        <multiselect
                          :options="AllMerchandiseItems"
                          v-model="optionObj.selectedItem"
                          :searchable="true"
                          :multiple="false"
                          :placeholder="'Item'"
                          label="merchandise_name"
                          track-by="merchandise_id"
                          style="min-width: 210px"
                          @input="
                            onSelectDefaultMerchandise(
                              $event,
                              'select',
                              optionIndex
                            )
                          "
                          @remove="
                            onSelectDefaultMerchandise(
                              $event,
                              'remove',
                              optionIndex
                            )
                          "
                        ></multiselect>
                      </div>
                    </div>
                    <div class="col-1">
                      <div class="input-material">
                        <input
                          v-model="optionObj.qty"
                          name="qty"
                          id="qty"
                          v-validate="'required'"
                          placeholder="."
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-xl-1">
                      <button
                        class="btn-transparent"
                        @click="removeComboItem(optionIndex)"
                      >
                        <img
                          src="@/assets/img/icons/minus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="row d-flex align-items-center justify-content-center border-top mt-4 mb-5 position-relative"
                >
                  <button
                    @click.prevent.stop="addComboItems()"
                    class="btn-transparent add-more-button"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2" v-else>
        <div class="d-flex">
          <div
            class="section-title mb-2 d-flex justify-content-between section-border section-border col-12"
            style="padding: 6px; align-items: center"
            v-b-toggle.merchandise_options
          >
            <span class="fs"> {{ $t("merchandise") }} Variants</span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
        </div>

        <b-collapse
          id="merchandise_options"
          v-model="sectionCollapse.merchandise_options"
        >
          <div class="new-border back rounded-10 col-12 pt-3 mb-2">
            <div class="row">
              <div class="col-12" style="margin-left: 1px">
                <div class="d-flex align-items-center mr-2 mb-3">
                  <div class="mx-2">
                    <b-form-radio
                      value="2"
                      class="j-radio"
                      @change="onClickChangeGroup($event)"
                      v-model="merchandiseObj.variantGroupBy"
                    >
                      <div>{{ "SIZE" }}</div>
                    </b-form-radio>
                  </div>
                  <div class="mx-2">
                    <b-form-radio
                      value="1"
                      class="j-radio"
                      @change="onClickChangeGroup($event)"
                      v-model="merchandiseObj.variantGroupBy"
                    >
                      <div>{{ "COLOR" }}</div>
                    </b-form-radio>
                  </div>
                </div>

                <div
                  v-for="(optionObj, optionIndex) in MerchandiseVariants"
                  :key="optionIndex"
                  class="mb-2"
                >
                  <div
                    class="row"
                    v-if="merchandiseObj.variantGroupBy == 1"
                    :class="optionObj.more ? 'borderBox' : ''"
                  >
                    <div class="col-11">
                      <div class="row">
                        <div class="col-2 d-flex align-items-center">
                          <div class="colorPicker w-100 mr-2">
                            <multiselect
                              :options="colorArray"
                              v-model="optionObj.selectedColor"
                              :searchable="true"
                              :multiple="false"
                              :placeholder="'Color'"
                              label="color_name"
                              track-by="color_id"
                              style="min-width: 210px"
                              @input="
                                onSelectColor($event, 'select', optionIndex)
                              "
                              @remove="
                                onSelectColor($event, 'remove', optionIndex)
                              "
                            ></multiselect>
                          </div>
                          <div
                            class="colorPreview"
                            :style="{ backgroundColor: optionObj.color_code }"
                          ></div>
                        </div>
                        <div class="col-3">
                          <div class="sizePicker">
                            <multiselect
                              :options="sizesArray"
                              v-model="optionObj.sizesArray"
                              :searchable="true"
                              :multiple="true"
                              :placeholder="'Sizes'"
                              label="size_name"
                              track-by="size_id"
                              style="min-width: 210px"
                            ></multiselect>
                          </div>
                        </div>
                        <div class="col-lg-3 col-xl-1 mb-1">
                          <!-- <label class="mb-0 mr-3">{{ $t("Upload image") }}</label> -->
                          <div class="d-flex align-items-center">
                            <button
                              class="fnb-btn-edit"
                              @click.prevent.stop="
                                setModalData(null, null, optionIndex, 'option')
                              "
                            >
                              Image
                            </button>

                            <label
                              style="display: none"
                              class="material-file-upload"
                              @click.prevent.stop="
                                setModalData(null, null, optionIndex, 'option')
                              "
                            >
                            </label>

                            <img
                              width="40"
                              height="40"
                              class="rounded ml-2 mr-2"
                              @click="showImage()"
                              :src="_GetImagePath(optionObj.mer_opt_image)"
                              v-if="
                                optionObj.hasOwnProperty('mer_opt_image') &&
                                  optionObj.mer_opt_image
                              "
                            />
                            <img
                              v-else
                              width="35"
                              height="35"
                              class="rounded ml-2 mr-2"
                              alt="Empty Image"
                              src="@/assets/img/icons/empty-image.svg"
                            />
                          </div>
                        </div>
                        <div class="col-2 mb-1 priceCheckBox">
                          <div class="d-flex align-items-center">
                            <b-form-checkbox
                              class="j-checkbox pb-0"
                              v-model="optionObj.has_different_price"
                              unchecked-value="N"
                              value="Y"
                            ></b-form-checkbox>
                            <span class="ml-1">Specific Price</span>
                          </div>
                        </div>
                        <div
                          class="col-1 mb-2"
                          v-if="optionObj.has_different_price == 'Y'"
                        >
                          <div class="input-material">
                            <input
                              v-model="optionObj.m_gross_amount"
                              name="pass_gross_amount"
                              id="pass_gross_amount"
                              v-validate="'required'"
                              placeholder="."
                              type="text"
                              @input="
                                handleChangePrice($event, 'option', optionIndex)
                              "
                            />
                            <label>Price</label>
                          </div>
                        </div>
                        <div
                          class="col-1 mb-1 opt_tax_select_pan"
                          v-if="optionObj.has_different_price == 'Y'"
                        >
                          <div class="dropdown-curve-container">
                            <label
                              :class="
                                optionObj.tax_setting_id ? 'shift-up' : ''
                              "
                            >
                              Tax
                            </label>
                            <multiselect
                              v-model="optionObj.selected_tax_settings"
                              placeholder=""
                              :options="ChargeSettingsList"
                              label="pas_charge_setting_name"
                              track-by="pas_id"
                              :multiple="false"
                              name="pas_charge_setting_name"
                              id="pas_charge_setting_name"
                              select-label="Select"
                              deselect-label="Remove"
                              @select="
                                onSelectTaxSetting(
                                  $event,
                                  'option',
                                  optionIndex
                                )
                              "
                            ></multiselect>
                          </div>
                        </div>
                        <div
                          class="col-1 mb-2"
                          v-if="optionObj.has_different_price == 'Y'"
                        >
                          <div class="input-material">
                            <input
                              v-model="optionObj.m_net_amount"
                              name="pass_net_amount"
                              placeholder="."
                              type="text"
                              :disabled="true"
                            />
                            <label>Net</label>
                          </div>
                        </div>
                        <div
                          class="col-1 mb-2"
                          v-if="optionObj.has_different_price == 'Y'"
                        >
                          <div class="input-material">
                            <input
                              v-model="optionObj.m_tax_amount"
                              name="pass_tax_amount"
                              placeholder="."
                              type="text"
                              :disabled="true"
                            />
                            <label>Tax</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-1">
                      <button
                        class="btn-transparent"
                        @click="removeMerchandiseOption(optionIndex)"
                      >
                        <img
                          src="@/assets/img/icons/minus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                    </div>
                    <b-collapse v-model="optionObj.more" class="col-12">
                    </b-collapse>
                  </div>
                  <div class="row" v-if="merchandiseObj.variantGroupBy == 2">
                    <div class="col-11">
                      <div class="row">
                        <div class="col-2">
                          <div class="colorPicker">
                            <multiselect
                              :options="sizesArray"
                              v-model="optionObj.selectedSize"
                              :searchable="true"
                              :multiple="false"
                              :placeholder="'Size'"
                              label="size_name"
                              track-by="size_id"
                              style="min-width: 210px"
                              @input="
                                onSelectSize($event, 'select', optionIndex)
                              "
                              @remove="
                                onSelectSize($event, 'remove', optionIndex)
                              "
                            ></multiselect>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="sizePicker">
                            <multiselect
                              :options="colorArray"
                              v-model="optionObj.colorArray"
                              :custom-label="customLabel"
                              :searchable="true"
                              :multiple="true"
                              :placeholder="'Colors'"
                              label="color_name"
                              track-by="color_id"
                              style="min-width: 210px"
                            >
                              <template slot="tag" slot-scope="props">
                                <span class="multiselect__tag colorSelector">
                                  <span class="d-flex align-items-center"
                                    ><div
                                      class="colorPrevier2 mr-1"
                                      :style="{
                                        backgroundColor:
                                          props.option.color_code,
                                      }"
                                    ></div>
                                    {{ props.option.color_name }}</span
                                  >
                                  <i
                                    aria-hidden="true"
                                    tabindex="1"
                                    @click="props.remove(props.option)"
                                    class="multiselect__tag-icon"
                                  ></i>
                                </span>
                              </template>
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-lg-3 col-xl-1 mb-1">
                          <!-- <label class="mb-0 mr-3">{{ $t("Upload image") }}</label> -->
                          <div class="d-flex align-items-center">
                            <button
                              class="fnb-btn-edit"
                              @click.prevent.stop="
                                setModalData(null, null, optionIndex, 'option')
                              "
                            >
                              Image
                            </button>

                            <label
                              style="display: none"
                              class="material-file-upload"
                              @click.prevent.stop="
                                setModalData(null, null, optionIndex, 'option')
                              "
                            >
                            </label>

                            <img
                              width="40"
                              height="40"
                              class="rounded ml-2 mr-2"
                              @click="showImage()"
                              :src="_GetImagePath(optionObj.mer_opt_image)"
                              v-if="
                                optionObj.hasOwnProperty('mer_opt_image') &&
                                  optionObj.mer_opt_image
                              "
                            />
                            <img
                              v-else
                              width="35"
                              height="35"
                              class="rounded ml-2 mr-2"
                              alt="Empty Image"
                              src="@/assets/img/icons/empty-image.svg"
                            />
                          </div>
                        </div>

                        <div class="col-2 priceCheckBox">
                          <div class="d-flex align-items-center">
                            <b-form-checkbox
                              class="j-checkbox pb-0"
                              v-model="optionObj.has_different_price"
                              unchecked-value="N"
                              value="Y"
                            ></b-form-checkbox>
                            <span class="ml-1">Specific Price</span>
                          </div>
                        </div>
                        <div
                          class="col-1 mb-2"
                          v-if="optionObj.has_different_price == 'Y'"
                        >
                          <div class="input-material">
                            <input
                              v-model="optionObj.m_gross_amount"
                              name="pass_gross_amount"
                              id="pass_gross_amount"
                              v-validate="'required'"
                              placeholder="."
                              type="text"
                              @input="
                                handleChangePrice($event, 'option', optionIndex)
                              "
                            />
                            <label>Price</label>
                          </div>
                        </div>
                        <div
                          class="col-1 mb-1 opt_tax_select_pan"
                          v-if="optionObj.has_different_price == 'Y'"
                        >
                          <div class="dropdown-curve-container">
                            <label
                              :class="
                                optionObj.tax_setting_id ? 'shift-up' : ''
                              "
                            >
                              Tax
                            </label>
                            <multiselect
                              v-model="optionObj.selected_tax_settings"
                              placeholder=""
                              :options="ChargeSettingsList"
                              label="pas_charge_setting_name"
                              track-by="pas_id"
                              :multiple="false"
                              name="pas_charge_setting_name"
                              id="pas_charge_setting_name"
                              select-label="Select"
                              deselect-label="Remove"
                              @select="
                                onSelectTaxSetting(
                                  $event,
                                  'option',
                                  optionIndex
                                )
                              "
                            ></multiselect>
                          </div>
                        </div>
                        <div
                          class="col-1 mb-2"
                          v-if="optionObj.has_different_price == 'Y'"
                        >
                          <div class="input-material">
                            <input
                              v-model="optionObj.m_net_amount"
                              name="pass_net_amount"
                              placeholder="."
                              type="text"
                              :disabled="true"
                            />
                            <label>Net</label>
                          </div>
                        </div>
                        <div
                          class="col-1 mb-2"
                          v-if="optionObj.has_different_price == 'Y'"
                        >
                          <div class="input-material">
                            <input
                              v-model="optionObj.m_tax_amount"
                              name="pass_tax_amount"
                              placeholder="."
                              type="text"
                              :disabled="true"
                            />
                            <label>Tax</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-1">
                      <button
                        class="btn-transparent"
                        @click="removeMerchandiseOption(optionIndex)"
                      >
                        <img
                          src="@/assets/img/icons/minus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                    </div>
                    <b-collapse v-model="optionObj.more" class="col-12">
                    </b-collapse>
                  </div>
                </div>
                <div
                  class="row d-flex align-items-center justify-content-center border-top mt-4 mb-5 position-relative"
                >
                  <button
                    @click.prevent.stop="
                      addMerchandiseOptions(merchandiseObj.variantGroupBy)
                    "
                    class="btn-transparent add-more-button"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2">
        <div class="d-flex">
          <div
            class="section-title mb-2 d-flex justify-content-between section-border section-border col-12"
            style="padding: 6px; align-items: center"
            v-b-toggle.pass_price
          >
            <span class="fs">Merchandise Price Details</span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
        </div>

        <b-collapse id="pass_price" v-model="sectionCollapse.pass_price">
          <div class="new-border back rounded-10 col-12 pt-3 mb-2">
            <div class="row">
              <div class="col-5">
                <div class="row">
                  <div class="col-6 mb-2">
                    <div class="input-material">
                      <input
                        v-model="merchandiseObj.m_gross_amount"
                        name="pass_gross_amount"
                        id="pass_gross_amount"
                        v-validate="'required'"
                        placeholder="."
                        type="text"
                        @input="handleChangePrice($event, 'main', null)"
                      />
                      <label>Merchandise Price</label>
                    </div>
                    <p
                      v-if="
                        submitted &&
                          isNaN(String(merchandiseObj.m_gross_amount))
                      "
                      class="error_message"
                    >
                      <span>Required.</span>
                    </p>
                  </div>

                  <div class="col-6 mb-1">
                    <div class="dropdown-curve-container">
                      <label
                        :class="merchandiseObj.tax_setting_id ? 'shift-up' : ''"
                      >
                        Charge Setting
                      </label>
                      <multiselect
                        v-model="merchandiseObj.selectedTaxSetting"
                        placeholder=""
                        :options="ChargeSettingsList"
                        label="pas_charge_setting_name"
                        track-by="pas_id"
                        :multiple="false"
                        name="pas_charge_setting_name"
                        id="pas_charge_setting_name"
                        select-label="Select"
                        deselect-label="Remove"
                        @select="onSelectTaxSetting($event, 'main', 0)"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-7">
                <table
                  class="swc-report-table mb-3"
                  border="1"
                  style="table-layout: auto; background: white"
                >
                  <thead>
                    <tr>
                      <th class="p-0" style="width: 240px"></th>
                      <th class="p-0" style="width: 240px"></th>
                      <th class="p-0" style="width: 100px"></th>
                      <th class="p-0" style="width: 100px"></th>
                      <th class="p-0" style="width: 170px"></th>
                      <th class="p-0" style="width: 125px"></th>
                      <th class="p-0" style="width: 125px"></th>
                      <th class="p-0" style="width: 140px"></th>
                      <th class="p-0" style="width: 185px"></th>
                      <th class="p-0" style="width: 140px"></th>
                      <th class="p-0" style="width: 180px"></th>
                    </tr>
                  </thead>
                  <tbody v-if="true">
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="3" class="font-weight-bold text-left">
                        Net Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{ currFormat(merchandiseObj["m_net_amount"] || 0) }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="3" class="font-weight-bold text-left">
                        Tax Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{ currFormat(merchandiseObj["m_tax_amount"] || 0) }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="3" class="font-weight-bold text-left">
                        Gross Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{ currFormat(merchandiseObj["m_gross_amount"] || 0) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <div class="col-12 mt-4 text-center">
        <button
          :disabled="btenable"
          @click.prevent.stop="OnFinalSubmit(true)"
          class="btn-blue"
        >
          {{ merchandise_id ? "Update" : "Add" }}
        </button>
      </div>
    </div>

    <b-modal
      size="lg"
      hide-footer
      ref="preview-modal"
      id="image-preview-modal"
      title="Merchandise Image"
    >
      <img
        :src="_GetImagePath(merchandiseObj.merchandise_image_url)"
        class="img-fluid"
      />
    </b-modal>

    <ImageGallery
      v-bind:propImageName="merchandiseObj.merchandise_name"
      :img_desc="merchandiseObj.m_description"
      :showPercentageLoader="true"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
      v-bind:category="'Generic'"
      v-bind:menu="'E'"
      :resetImgData="false"
      :title="
        `Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
      "
    ></ImageGallery>

    <b-modal
      id="confirmation_grpup_change"
      title="Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="text-center pb-1 my-3">
        <p class="fs-16 mb-2">
          Are you sure you want to switch? Data for the current group will get
          lost.
        </p>
        <span class="mx-1"></span>
        <button
          class="btn btn-success btn-success-lg px-4 fs-14"
          @click.prevent.stop="onChangeGroup()"
        >
          Proceed
        </button>
        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation_grpup_change')"
        >
          Cancel
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import moment from "moment";
  import MasterService from "@/services/MasterService";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import { VueEditor } from "vue2-editor";
  import _ from "lodash";
  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";
  import ImageGallery from "../../ImageGallery/imageGalleryModal";
  import { mapGetters } from "vuex";

  export default {
    components: { VueTimepicker, VueEditor, VueCropper, ImageGallery },
    data() {
      return {
        newEvent: null,
        setImage: {
          imagename: "",
          index: null,
          type: null,
        },
        set_width: null,
        set_height: null,
        showModal: false,
        merchandise_id: null,
        errorIndex: null,
        aggregatorUsersList: [],
        ChargeSettingsList: [],
        set_height: null,
        set_width: null,
        showModal: null,
        btenable: false,

        submitted: false,
        cinemasList: [],
        Cinemas: [],
        sizesArray: [],
        colorArray: [],
        Categories: [],
        Tags: [],
        AllMerchandiseItems: [],

        MerchandiseItems: [],

        comboObj: {
          item_id: null,
          item_name: "",
          selectedItem: null,
          qty: 1,
          altername_items: [],
        },

        MerchandiseVariants: [],
        merchandiseObj: {
          merchandise_id: null,
          product_code: "",
          merchandise_name: "",
          alt_merchandise_name: "",
          m_description: "",
          merchandise_image_url: "",
          category_id: null,
          category_name: "",
          selectedCategory: "",
          tax_setting_id: null,
          tax_setting: [],
          charge_array: [],
          selectedTaxSetting: "",
          tax_setting_name: "",
          m_net_amount: 0,
          m_tax_amount: 0,
          m_gross_amount: 0,
          tax_1: 0,
          tax_2: 0,
          merc_sales_channels: [],
          available_on_specific_cinemas: "N",
          cinema_ids: [],
          is_non_sellable: "N",
          is_combo_pack: "N",
          merchandise_is_active: "Y",
          merchandiseOptions: [],
          combo_pack: [],
          merch_tags: [],
          tags: [],
          variantGroupBy: 2, //1 for color and 2 for sizes
        },
        merchandiseOptionObj_1: {
          color_id: null,
          color_name: null,
          selectedColor: null,
          mer_opt_image: null,
          sizesArray: [],
          m_net_amount: 0,
          m_tax_amount: 0,
          m_gross_amount: 0,
          stock_available: 0,
          mer_opt_is_active: "Y",
        },
        tempSizeObj: {
          size_id: null,
          size_name: "",
          selectedSize: "",
        },
        merchandiseOptionObj_2: {
          size_id: null,
          size_name: null,
          selectedSize: null,
          mer_opt_image: null,
          colorArray: [],
          m_net_amount: 0,
          m_tax_amount: 0,
          m_gross_amount: 0,
          stock_available: 0,
          mer_opt_is_active: "Y",
        },
        tempColorArray: {
          color_id: null,
          color_name: null,
          selectedColor: null,
        },
        merchandiseOptionObj: {
          mer_opt_id: null,
          merchandise_id: null,
          size_id: null,
          size_name: "",
          selectedSize: "",
          selectedColor: "",
          mer_opt_image: null,
          m_net_amount: 0,
          m_tax_amount: 0,
          m_gross_amount: 0,
          stock_available: 0,
          mer_opt_is_active: "Y",
        },
        //Collapse
        sectionCollapse: {
          pass_settings: true,
          pass_config: true,
          pass_details: true,
          pass_price: true,

          merchandise_details: true,
          merchandise_options: true,
        },

        weekDays: {
          selectAll: true,
          sunday: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
        },
      };
    },
    computed: {
      ...mapGetters(["finalImagePath"]),
    },
    watch: {
      finalImagePath(newval) {
        if (
          (this.setImage["type"] =
            "option" && !isNaN(String(this.setImage["index"])))
        ) {
          this.MerchandiseVariants[
            this.setImage["index"]
          ].mer_opt_image = newval;
        } else {
          this.merchandiseObj.merchandise_image_url = newval;
        }
        this.$forceUpdate();
        console.log("this.merchandiseObj", this.merchandiseObj);
      },
    },
    beforeMount() {
      const { merchandise_id } = this.$route.query;
      this.merchandise_id = merchandise_id || null;

      if (merchandise_id) {
        this.getMerchandiseInformation(merchandise_id);
      } else {
        this.getTaxSettings();
        this.getMerchandiseSizes();
        this.getMerchandiseColors();
        this.getMerchandiseCategories();
        this.getCinemasList();
        this.getMerchandiseItems();
        this.getMerchandiseTags();
        //   this.getCinemasList();
        //   this.getPosAggregatorUsers();
      }
    },
    mounted() {},
    methods: {
      onClickChangeGroup(event) {
        this.newEvent = event;
        this.merchandiseObj.variantGroupBy = event == 1 ? "2" : "1";
        this.$bvModal.show("confirmation_grpup_change");
      },
      onChangeGroup() {
        this.merchandiseObj.variantGroupBy = this.newEvent;
        this.MerchandiseVariants = [];
        this.$bvModal.hide("confirmation_grpup_change");
      },
      onToggleMoreSettings(Variants, index) {
        this.MerchandiseVariants.forEach((vari, varIndex) => {
          if (index != varIndex) {
            vari["more"] = false;
          }
        });

        Variants.more = !Variants.more;
      },
      customLabel({ color_name }) {
        return color_name;
      },
      getMerchandiseCategories: function() {
        this.Categories = [];
        let payload = {
          tableName: "ms_merchandise_categories",
          cat_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.Categories = data.Records;
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      getMerchandiseTags: function() {
        this.Tags = [];
        let payload = {
          tableName: "ms_merchandise_tags",
          tag_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.Tags = data.Records;
                if (
                  this.merchandiseObj["tags"] &&
                  this.merchandiseObj["tags"].length
                ) {
                  this.merchandiseObj["merch_tags"] = data.Records.filter((x) =>
                    this.merchandiseObj["tags"].includes(String(x.m_tag_id))
                  );
                }
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      getMerchandiseItems: function() {
        this.AllMerchandiseItems = [];
        let payload = {
          tableName: "ms_merchandise",
          merchandise_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.AllMerchandiseItems = data.Records.filter(
                  (x) =>
                    x.is_combo_pack == "N" &&
                    x.merchandise_id != this.merchandise_id
                );
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      getMerchandiseColors: function() {
        this.colorArray = [];
        let payload = {
          tableName: "ms_merchandise_colors",
          color_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.colorArray = data.Records;
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      getMerchandiseSizes: function() {
        this.sizesArray = [];
        let payload = {
          tableName: "ms_sizes",
          size_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.sizesArray = data.Records;
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      onSelectDefaultMerchandise(merc, type, optionIndex) {
        console.log("merc", merc);
        if (type == "select") {
          this.merchandiseObj.combo_pack[optionIndex].item_id =
            merc["merchandise_id"];
          this.merchandiseObj.combo_pack[optionIndex].item_name =
            merc["merchandise_name"];
        } else {
          this.merchandiseObj.combo_pack[optionIndex].item_id = null;
          this.merchandiseObj.combo_pack[optionIndex].item_name = "";
        }
      },
      onSelectCategory(category, type) {
        if (type == "remove") {
          this.merchandiseObj.category_id = null;
          this.merchandiseObj.category_name = "";
          this.merchandiseObj.selectedCategory = "";
        } else {
          this.merchandiseObj.category_id = category.m_cat_id;
          this.merchandiseObj.category_name = category.m_cat_name;
          this.merchandiseObj.selectedCategory = category;
        }
      },
      onSelectSize(size, type, optionIndex) {
        // if (type == "remove") {
        //   this.merchandiseObj.merchandiseOptions[optionIndex].size_id = null;
        //   this.merchandiseObj.merchandiseOptions[optionIndex].size_name = "";
        //   this.merchandiseObj.merchandiseOptions[optionIndex].selectedSize = "";
        // } else {
        //   this.merchandiseObj.merchandiseOptions[optionIndex].size_id =
        //     size["size_id"];
        //   this.merchandiseObj.merchandiseOptions[optionIndex].size_name =
        //     size["size_name"];
        //   this.merchandiseObj.merchandiseOptions[optionIndex].selectedSize = size;
        // }
        console.log("size", size);
        if (type == "select") {
          this.MerchandiseVariants[optionIndex].size_id = size["size_id"];
          this.MerchandiseVariants[optionIndex].size_name = size["size_name"];
          this.MerchandiseVariants[optionIndex].selectedSize = size;
        } else {
          this.MerchandiseVariants[optionIndex].size_id = null;
          this.MerchandiseVariants[optionIndex].size_name = "";
          this.MerchandiseVariants[optionIndex].selectedSize = "";
        }
      },
      onSelectColor(color, type, optionIndex) {
        console.log("color", color);
        if (type == "select") {
          this.MerchandiseVariants[optionIndex].color_id = color["color_id"];
          this.MerchandiseVariants[optionIndex].color_name =
            color["color_name"];
          this.MerchandiseVariants[optionIndex].color_code =
            color["color_code"];
          this.MerchandiseVariants[optionIndex].selectedColor = color;
        } else {
          this.MerchandiseVariants[optionIndex].color_id = null;
          this.MerchandiseVariants[optionIndex].color_name = "";
          this.MerchandiseVariants[optionIndex].color_code = "";
          this.MerchandiseVariants[optionIndex].selectedColor = "";
        }
      },
      showImage: function() {
        this.$refs["preview-modal"].show();
      },
      setModalData(height, width, index = null, type = null) {
        this.set_height = height;
        this.set_width = width;
        this.showModal = !this.showModal;
        this.setImage["imagename"] = "";
        this.setImage["index"] = index;
        this.setImage["type"] = type;
      },
      getMerchandiseInformation(merchandise_id) {
        if (merchandise_id) {
          let loader = this.$loading.show();
          let payload = {
            merchandise_id: merchandise_id,
          };
          MasterService.GetMerchandiseDetails(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.merchandiseObj = data.Records;
                this.MerchandiseVariants = data.MerchandiseVariants;
              } else {
                console.log("Error:", data.message);
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            })
            .finally(() => {
              loader.hide();
              this.getTaxSettings(this.merchandiseObj["tax_setting_id"]);
              this.getMerchandiseSizes();
              this.getMerchandiseColors();
              this.getMerchandiseCategories();
              this.getMerchandiseItems();
              this.getMerchandiseTags();
              // this.getCinemasList();
              // this.getPosAggregatorUsers();
            });
        }
      },
      onSelectTaxSetting(taxSetting, type = "main", index) {
        if (type == "main") {
          this.merchandiseObj.tax_setting_id = taxSetting.pas_id;
          this.merchandiseObj["tax_setting_name"] =
            taxSetting.pas_charge_setting_name;
          this.getCinemaCharges(taxSetting, 0, type);
        } else if (type == "option" && !isNaN(String(index))) {
          this.MerchandiseVariants[index].tax_setting_id = taxSetting.pas_id;
          this.MerchandiseVariants[index]["tax_setting_name"] =
            taxSetting.pas_charge_setting_name;
          this.getCinemaCharges(taxSetting, index, type);
        }
      },
      handleChangePrice(event, type = "main", index) {
        if (type == "main") {
          const {
            final_net_amount,
            final_tax_amount,
            final_gross_amount,
            charge_array,
            tax_setting,
          } = this.cinemaChargesCalculation({
            index: 0,
            gross_amount_params: parseFloat(
              this.merchandiseObj.m_gross_amount || 0
            ),
            charge_array: this.merchandiseObj.charge_array || [],
            tax_setting: this.merchandiseObj.tax_setting || [],
          });

          this.merchandiseObj["m_net_amount"] = parseFloat(
            final_net_amount || 0
          );
          this.merchandiseObj["m_tax_amount"] = parseFloat(
            final_tax_amount || 0
          );
          this.merchandiseObj["tax_setting"] = tax_setting || [];
          this.merchandiseObj["charge_array"] = charge_array || [];
        } else if (type == "option" && !isNaN(String(index))) {
          const {
            final_net_amount,
            final_tax_amount,
            final_gross_amount,
            charge_array,
            tax_setting,
          } = this.cinemaChargesCalculation({
            index: index,
            gross_amount_params: parseFloat(
              this.MerchandiseVariants[index].m_gross_amount || 0
            ),
            charge_array: this.MerchandiseVariants[index].charge_array || [],
            tax_setting: this.MerchandiseVariants[index].tax_setting || [],
          });

          this.MerchandiseVariants[index]["m_net_amount"] = parseFloat(
            final_net_amount || 0
          );
          this.MerchandiseVariants[index]["m_tax_amount"] = parseFloat(
            final_tax_amount || 0
          );
          this.MerchandiseVariants[index]["tax_setting"] = tax_setting || [];
          this.MerchandiseVariants[index]["charge_array"] = charge_array || [];

          let tax_1 = null;
          let tax_2 = null;
          if (
            this.MerchandiseVariants[index]["tax_setting"] &&
            this.MerchandiseVariants[index]["tax_setting"].length
          ) {
            let checkVAT = this.MerchandiseVariants[index][
              "tax_setting"
            ].filter((_tax) => _tax["charge_name"].toLowerCase() == "vat");
            let otherTax = this.MerchandiseVariants[index][
              "tax_setting"
            ].filter((_tax) => _tax["charge_name"].toLowerCase() != "vat");
            if (checkVAT && checkVAT.length) {
              tax_1 = parseFloat(checkVAT[0]["cinemacharges"] || 0);
              tax_2 =
                otherTax && otherTax.length
                  ? parseFloat(otherTax[0]["cinemacharges"] || 0)
                  : 0;
            } else {
              tax_1 = this.MerchandiseVariants[index]["tax_setting"][0]
                ? parseFloat(
                    this.MerchandiseVariants[index]["tax_setting"][0][
                      "cinemacharges"
                    ] || 0
                  )
                : 0;
              tax_2 = this.MerchandiseVariants[index]["tax_setting"][1]
                ? parseFloat(
                    this.MerchandiseVariants[index]["tax_setting"][1][
                      "cinemacharges"
                    ] || 0
                  )
                : 0;
            }
          }

          this.MerchandiseVariants[index]["tax_1"] = tax_1;
          this.MerchandiseVariants[index]["tax_2"] = tax_2;
        }
      },
      getCinemaCharges: function(charge_setting, index = 0, type = "main") {
        if (type == "main") {
          this.merchandiseObj.charge_array = [];
          this.merchandiseObj.tax_setting = [];

          let cinemaChargesArray = charge_setting["charge_array"] || [];
          this.merchandiseObj.charge_array =
            charge_setting["charge_array"] || [];

          cinemaChargesArray.map((x) => {
            let obj = {
              pas_order: x.pas_order || 0,
              charge_name: x.ct_name,
              cinemacharges: 0,
              charge_value: x.pas_charge_value,
              ct_id: x.ct_id,
              ct_code: x.ct_code,
              pas_id: x.pas_id,
              pas_is_percentage: x.pas_is_percentage,
            };
            this.merchandiseObj.tax_setting.push(obj);
          });

          const {
            final_net_amount,
            final_tax_amount,
            final_gross_amount,
            charge_array,
            tax_setting,
          } = this.cinemaChargesCalculation({
            index: index,
            gross_amount_params: parseFloat(
              this.merchandiseObj.m_gross_amount || 0
            ),
            charge_array: cinemaChargesArray || [],
            tax_setting: this.merchandiseObj.tax_setting,
          });

          this.merchandiseObj["m_net_amount"] = parseFloat(
            final_net_amount || 0
          );
          this.merchandiseObj["m_tax_amount"] = parseFloat(
            final_tax_amount || 0
          );
          this.merchandiseObj["tax_setting"] = tax_setting || [];
          this.merchandiseObj["charge_array"] = charge_array || [];

          let tax_1 = null;
          let tax_2 = null;
          if (
            this.merchandiseObj["tax_setting"] &&
            this.merchandiseObj["tax_setting"].length
          ) {
            let checkVAT = this.merchandiseObj["tax_setting"].filter(
              (_tax) => _tax["charge_name"].toLowerCase() == "vat"
            );
            let otherTax = this.merchandiseObj["tax_setting"].filter(
              (_tax) => _tax["charge_name"].toLowerCase() != "vat"
            );
            if (checkVAT && checkVAT.length) {
              tax_1 = parseFloat(checkVAT[0]["cinemacharges"] || 0);
              tax_2 =
                otherTax && otherTax.length
                  ? parseFloat(otherTax[0]["cinemacharges"] || 0)
                  : 0;
            } else {
              tax_1 = this.merchandiseObj["tax_setting"][0]
                ? parseFloat(
                    this.merchandiseObj["tax_setting"][0]["cinemacharges"] || 0
                  )
                : 0;
              tax_2 = this.merchandiseObj["tax_setting"][1]
                ? parseFloat(
                    this.merchandiseObj["tax_setting"][1]["cinemacharges"] || 0
                  )
                : 0;
            }
          }

          this.merchandiseObj["tax_1"] = tax_1;
          this.merchandiseObj["tax_2"] = tax_2;
        } else if (type == "option") {
          this.MerchandiseVariants[index].charge_array = [];
          this.MerchandiseVariants[index].tax_setting = [];

          let cinemaChargesArray = charge_setting["charge_array"] || [];
          this.MerchandiseVariants[index].charge_array =
            charge_setting["charge_array"] || [];

          cinemaChargesArray.map((x) => {
            let obj = {
              pas_order: x.pas_order || 0,
              charge_name: x.ct_name,
              cinemacharges: 0,
              charge_value: x.pas_charge_value,
              ct_id: x.ct_id,
              ct_code: x.ct_code,
              pas_id: x.pas_id,
              pas_is_percentage: x.pas_is_percentage,
            };
            this.MerchandiseVariants[index].tax_setting.push(obj);
          });

          const {
            final_net_amount,
            final_tax_amount,
            final_gross_amount,
            charge_array,
            tax_setting,
          } = this.cinemaChargesCalculation({
            index: index,
            gross_amount_params: parseFloat(
              this.MerchandiseVariants[index].m_gross_amount || 0
            ),
            charge_array: cinemaChargesArray || [],
            tax_setting: this.MerchandiseVariants[index].tax_setting,
          });

          this.MerchandiseVariants[index]["m_net_amount"] = parseFloat(
            final_net_amount || 0
          );
          this.MerchandiseVariants[index]["m_tax_amount"] = parseFloat(
            final_tax_amount || 0
          );
          this.MerchandiseVariants[index]["tax_setting"] = tax_setting || [];
          this.MerchandiseVariants[index]["charge_array"] = charge_array || [];

          let tax_1 = null;
          let tax_2 = null;
          if (
            this.MerchandiseVariants[index]["tax_setting"] &&
            this.MerchandiseVariants[index]["tax_setting"].length
          ) {
            let checkVAT = this.MerchandiseVariants[index][
              "tax_setting"
            ].filter((_tax) => _tax["charge_name"].toLowerCase() == "vat");
            let otherTax = this.MerchandiseVariants[index][
              "tax_setting"
            ].filter((_tax) => _tax["charge_name"].toLowerCase() != "vat");
            if (checkVAT && checkVAT.length) {
              tax_1 = parseFloat(checkVAT[0]["cinemacharges"] || 0);
              tax_2 =
                otherTax && otherTax.length
                  ? parseFloat(otherTax[0]["cinemacharges"] || 0)
                  : 0;
            } else {
              tax_1 = this.MerchandiseVariants[index]["tax_setting"][0]
                ? parseFloat(
                    this.MerchandiseVariants[index]["tax_setting"][0][
                      "cinemacharges"
                    ] || 0
                  )
                : 0;
              tax_2 = this.MerchandiseVariants[index]["tax_setting"][1]
                ? parseFloat(
                    this.MerchandiseVariants[index]["tax_setting"][1][
                      "cinemacharges"
                    ] || 0
                  )
                : 0;
            }
          }

          this.MerchandiseVariants[index]["tax_1"] = tax_1;
          this.MerchandiseVariants[index]["tax_2"] = tax_2;
        }
      },
      cinemaChargesCalculation: function({
        index,
        gross_amount_params = 0,
        charge_array = [],
        tax_setting = [],
      }) {
        let tempChargeArray = charge_array;

        let final_net_amount = 0;
        let final_tax_amount = 0;
        let final_gross_amount = 0;

        if (true) {
          let grosss = this.getSafe(() => tempChargeArray.map((x) => x), [])
            .filter((z) => z.pas_is_on_gross_amount == "Y")
            .filter((g) =>
              String(g.ct_name)
                .toUpperCase()
                .includes("VAT")
            )
            .filter((g) => g.pas_is_percentage === "Y");

          let nets = this.getSafe(() => tempChargeArray.map((x) => x), [])
            .filter((z) => z.pas_is_on_gross_amount == "N")
            .filter(
              (g) =>
                !String(g.ct_name)
                  .toUpperCase()
                  .includes("VAT")
            )
            .filter((g) => g.pas_is_percentage === "Y");

          let misc_products = this.getSafe(
            () => tempChargeArray.map((x) => x),
            []
          )
            .filter((g) => g.pas_is_percentage === "N")
            .filter(
              (g) =>
                !String(g.ct_name)
                  .toUpperCase()
                  .includes("VAT")
            );

          console.log({
            nets,
            grosss,
            misc_products,
            taxes: tempChargeArray.map((x) => x),
          });

          let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
          let vat_percent = this.getFloat(
            this.getSafe(() => grosss[0].pas_charge_value, 0)
          );

          let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
          let net_1_percent = this.getFloat(
            this.getSafe(() => nets[0].pas_charge_value, "0")
          );

          let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
          let net_2_percent = this.getFloat(
            this.getSafe(() => nets[1].pas_charge_value, "0")
          );

          let misc_product_rate_pas_id = this.getSafe(
            () => misc_products[0].pas_id
          );
          let misc_product_rate_1 = this.getFloat(
            this.getSafe(() => misc_products[0].pas_charge_value, "0")
          );
          let misc_rate_exist =
            misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;
          let amount = this.getFloat(gross_amount_params || 0);

          /** Gross */
          let G = amount;
          /** Taxable/Net */
          let E = this.getFloat(amount / (1 + vat_percent / 100));
          /** VAT */
          let F = this.getFloat((vat_percent / 100) * E);
          /** 3D/Prod */
          let B = this.getFloat(misc_product_rate_1 / (1 + vat_percent / 100));
          /** Ticket Rate */
          let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
          let A = this.getFloat((E - B) / totalPerCentOfA);
          /** Film Dev Tax */
          let C = this.getFloat((net_1_percent / 100) * A);
          /** State & Local Ent Tax */
          let D = this.getFloat((net_2_percent / 100) * A);

          console.log({
            amount,
            vat_percent,
            net_1_percent,
            net_2_percent,
            totalPerCentOfA,
            misc_rate_exist,
            misc_product_rate_1,
          });
          console.log({
            Gross: G,
            Net: E,
            VAT: F,
            FDT: C,
            SLE: D,
            "3D": B,
            TicketRate: A,
            ProductRate: B,
          });

          let NET_AMT = E;
          let BASE_RATE = A;
          let NET_1_AMT = C;
          let NET_2_AMT = D;
          let NET_3_AMT = B; // misc_product_rate_1
          let VAT_AMT = F;
          let Gross = G;

          final_net_amount = parseFloat(BASE_RATE + NET_3_AMT);

          tempChargeArray.map((x, i) => {
            let index = tax_setting.findIndex(
              (zz) => zz.ct_id == x.charge_type_id
            );

            if (x.pas_id == net_1_pas_id) {
              x.cinemacharges = NET_1_AMT;
            }
            if (x.pas_id == net_2_pas_id) {
              x.cinemacharges = NET_2_AMT;
            }
            if (x.pas_id == misc_product_rate_pas_id) {
              x.cinemacharges = NET_3_AMT;
            }

            if (x.pas_id == vat_pas_id) {
              x.cinemacharges = VAT_AMT;
            }

            tax_setting[index].cinemacharges = x.cinemacharges || 0;
          });

          let unitNet = parseFloat(final_net_amount);

          final_net_amount = parseFloat(parseFloat(unitNet || 0)).toFixed(4);

          final_tax_amount = parseFloat(
            tax_setting.reduce(
              (acc, { cinemacharges }) =>
                acc +
                +parseFloat(cinemacharges || 0).toFixed(
                  this.MIN_FRACTION_DIGITS
                ),
              0
            )
          ).toFixed(this.MIN_FRACTION_DIGITS);
        }

        return {
          final_net_amount: final_net_amount,
          final_tax_amount: final_tax_amount,
          final_gross_amount: final_gross_amount,
          charge_array: charge_array,
          tax_setting: tax_setting,
        };
      },
      getFloat(val = "0", fractionDigits = 8) {
        let parsed = parseFloat(String(val) || "0") || parseFloat("0");
        return parseFloat(parsed.toFixed(fractionDigits));
      },
      getPosAggregatorUsers: function() {
        MasterService.GetPosAggregatorUsers()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.aggregatorUsersList = data.Records;

              // if (this.merchandiseObj["sales_channels"]) {
              //   let tempArray =
              //     this.merchandiseObj["sales_channels"].split(", ") || [];
              //   this.merchandiseObj["selected_sales_channels"] =
              //     data.Records.filter((_user) =>
              //       tempArray.includes(String(_user.user_id))
              //     );
              // }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show(err);
          });
      },
      getTaxSettings(taxSettingId) {
        MasterService.GetTaxSettings()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ChargeSettingsList = data.Records;

              if (this.merchandiseObj["tax_setting_id"]) {
                let taxSetting = data.Records.filter(
                  (_pas) => _pas.pas_id == this.merchandiseObj["tax_setting_id"]
                );
                if (taxSetting && taxSetting.length) {
                  this.onSelectTaxSetting(taxSetting[0], "main", 0);
                }
              }

              let checkVariantArray = this.MerchandiseVariants.filter(
                (_x) => (_x) => _x["tax_setting_id"]
              );

              if (checkVariantArray && checkVariantArray.length) {
                this.MerchandiseVariants.forEach((_var, index) => {
                  if (_var["tax_setting_id"]) {
                    let taxSetting = data.Records.filter(
                      (_pas) => _pas.pas_id == _var["tax_setting_id"]
                    );
                    if (taxSetting && taxSetting.length) {
                      this.onSelectTaxSetting(taxSetting[0], "option", index);
                    }
                  }
                });
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      addMerchandiseOptions: function(type_id = 1) {
        if (type_id == 1) {
          this.MerchandiseVariants.push({
            mer_opt_id: null,
            color_id: null,
            color_name: null,
            color_code: null,
            selectedColor: null,
            mer_opt_image: null,
            sizesArray: [],
            has_different_price: "N",
            m_net_amount: 0,
            m_tax_amount: 0,
            m_gross_amount: 0,
            tax_1: 0,
            tax_2: 0,
            tax_setting_id: null,
            tax_setting_name: null,
            selected_tax_setting: null,
            taxes: [],
            tax_setting: [],
            charge_array: [],
            cinemas: [],
            stock_available: 0,
            mer_opt_is_active: "Y",
            more: false,
          });
        } else {
          this.MerchandiseVariants.push({
            mer_opt_id: null,
            size_id: null,
            size_name: null,
            selectedSize: null,
            mer_opt_image: null,
            colorArray: [],
            has_different_price: "N",
            m_net_amount: 0,
            m_tax_amount: 0,
            m_gross_amount: 0,
            tax_1: 0,
            tax_2: 0,
            tax_setting_id: null,
            tax_setting_name: null,
            selected_tax_setting: null,
            taxes: [],
            tax_setting: [],
            charge_array: [],
            cinemas: [],
            stock_available: 0,
            mer_opt_is_active: "Y",
            more: false,
          });
        }
      },
      removeMerchandiseOption: function(index) {
        this.MerchandiseVariants.splice(index, 1);
      },
      addComboItems: function(type_id = 1) {
        this.merchandiseObj.combo_pack.push({
          mer_mapping_id: null,
          item_id: null,
          item_name: "",
          qty: 1,
          selectedItem: null,
        });
      },
      removeComboItem: function(index) {
        this.merchandiseObj.combo_pack.splice(index, 1);
      },
      getCinemasList: function() {
        this.cinemasList = [];
        let payload = {
          tableName: "ms_cinemas",
          cine_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.Cinemas = data.Records;
                this.cinemasList = [
                  {
                    label: "Select All Cinemas",
                    Cinemas: data.Records,
                  },
                ];
                // if (this.merchandiseObj["cinema_ids"]) {
                //   let tempArray =
                //     this.merchandiseObj["cinema_ids"].split(", ") || [];
                //   this.merchandiseObj["selected_cinemas"] = data.Records.filter(
                //     (_cine) => tempArray.includes(String(_cine.cine_id))
                //   );
                // }
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      validationCheck(showMsg = true) {
        this.errorIndex = null;
        let errorMsg = ``;
        let errorCount = 0;
        let errorIndex = null;

        if (!this.merchandiseObj["merchandise_name"]) {
          errorCount++;
          errorMsg = `Please Enter Merchandise Name`;
        } else if (!this.merchandiseObj["category_id"]) {
          errorCount++;
          errorMsg = `Please Select Merchandise Category`;
        } else if (isNaN(String(this.merchandiseObj["m_gross_amount"]))) {
          errorCount++;
          errorMsg = `Please Enter Valid Amount`;
        } else if (!this.merchandiseObj["tax_setting_id"]) {
          errorCount++;
          errorMsg = `Please Enter Valid Tax Settings`;
        } else if (
          this.merchandiseObj["is_combo_pack"] == "Y" &&
          !this.merchandiseObj.combo_pack.length
        ) {
          errorCount++;
          errorMsg = `Please Add Combo Items`;
        } else {
          if (this.MerchandiseVariants.length) {
            if (this.merchandiseObj.variantGroupBy == 1) {
              this.MerchandiseVariants.forEach((_config, index) => {
                if (!_config["color_id"]) {
                  errorCount++;
                  errorMsg = `Please Select Valid Color`;
                  errorIndex = index;
                } else if (
                  _config["tax_setting_id"] &&
                  isNaN(String(_config["m_gross_amount"]))
                ) {
                  errorCount++;
                  errorMsg = `Please Select Valid Item Price`;
                  errorIndex = index;
                } else if (
                  isNaN(String(_config["m_gross_amount"])) &&
                  !_config["tax_setting_id"]
                ) {
                  errorCount++;
                  errorMsg = `Please Select Valid Tax Setting`;
                  errorIndex = index;
                } else if (
                  _config["has_different_price"] == "Y" &&
                  isNaN(String(_config["m_gross_amount"]))
                ) {
                  errorCount++;
                  errorMsg = `Please Enter Valid Amount`;
                  errorIndex = index;
                } else if (
                  _config["has_different_price"] == "Y" &&
                  !_config["tax_setting_id"]
                ) {
                  errorCount++;
                  errorMsg = `Please Select Tax Setting`;
                  errorIndex = index;
                }
              });
            } else if (this.merchandiseObj.variantGroupBy == 2) {
              this.MerchandiseVariants.forEach((_config, index) => {
                if (!_config["size_id"]) {
                  errorCount++;
                  errorMsg = `Please Select Valid Size`;
                  errorIndex = index;
                } else if (
                  _config["tax_setting_id"] &&
                  isNaN(String(_config["m_gross_amount"]))
                ) {
                  errorCount++;
                  errorMsg = `Please Select Valid Item Price`;
                  errorIndex = index;
                } else if (
                  isNaN(String(_config["m_gross_amount"])) &&
                  !_config["tax_setting_id"]
                ) {
                  errorCount++;
                  errorMsg = `Please Select Valid Tax Setting`;
                  errorIndex = index;
                } else if (
                  _config["has_different_price"] == "Y" &&
                  isNaN(String(_config["m_gross_amount"]))
                ) {
                  errorCount++;
                  errorMsg = `Please Enter Valid Amount`;
                  errorIndex = index;
                } else if (
                  _config["has_different_price"] == "Y" &&
                  !_config["tax_setting_id"]
                ) {
                  errorCount++;
                  errorMsg = `Please Select Tax Setting`;
                  errorIndex = index;
                }
              });
            }
          }
        }
        if (errorCount > 0) {
          if (showMsg) {
            this.$toasted.show(errorMsg);
          }
          this.errorIndex = errorIndex;
          return false;
        } else {
          this.errorIndex = null;
          return true;
        }
      },
      createVariantArray() {
        if (this.MerchandiseVariants.length) {
          if (this.merchandiseObj.variantGroupBy == 1) {
            this.MerchandiseVariants.forEach((_config, index) => {
              if (_config.sizesArray && _config.sizesArray.length) {
                _config.sizesArray.forEach((_size) => {
                  let finalVariantObj = {
                    mer_opt_id:
                      _size["mer_opt_id"] || _config["mer_opt_id"] || null,
                    size_id: _size["size_id"] || null,
                    size_name: _size["size_name"] || null,
                    color_id: _config["color_id"] || null,
                    color_name: _config["color_name"] || null,
                    color_code: _config["color_code"] || null,
                    mer_opt_image: _config["mer_opt_image"] || null,
                    has_different_price: _config["has_different_price"] || "N",
                    m_net_amount: parseFloat(
                      _config["m_net_amount"] || 0
                    ).toFixed(4),
                    m_tax_amount: parseFloat(
                      _config["m_tax_amount"] || 0
                    ).toFixed(4),
                    m_gross_amount: parseFloat(
                      _config["m_gross_amount"] || 0
                    ).toFixed(4),
                    tax_setting_id: _config["tax_setting_id"] || null,
                    tax_setting_name: _config["tax_setting_name"] || null,
                    tax_1: parseFloat(_config["tax_1"] || 0),
                    tax_2: parseFloat(_config["tax_2"] || 0),
                    selected_tax_setting:
                      _config["selected_tax_setting"] || null,
                    taxes: _config["taxes"] || [],
                    tax_setting: _config["tax_setting"] || [],
                    charge_array: _config["charge_array"] || [],
                    cinemas: _config["cinemas"] || [],
                    group_index: index,
                    stock_available: _config["stock_available"] || 0,
                    mer_opt_is_active: _config["mer_opt_is_active"] || "N",
                  };
                  this.merchandiseObj.merchandiseOptions.push(finalVariantObj);
                });
              } else {
                let finalVariantObj = {
                  mer_opt_id: _config["mer_opt_id"] || null,
                  size_id: null,
                  size_name: null,
                  color_id: _config["color_id"] || null,
                  color_name: _config["color_name"] || null,
                  color_code: _config["color_code"] || null,
                  mer_opt_image: _config["mer_opt_image"] || null,
                  has_different_price: _config["has_different_price"] || "N",
                  m_net_amount: parseFloat(
                    _config["m_net_amount"] || 0
                  ).toFixed(4),
                  m_tax_amount: parseFloat(
                    _config["m_tax_amount"] || 0
                  ).toFixed(4),
                  m_gross_amount: parseFloat(
                    _config["m_gross_amount"] || 0
                  ).toFixed(4),
                  tax_setting_id: _config["tax_setting_id"] || null,
                  tax_setting_name: _config["tax_setting_name"] || null,
                  tax_1: parseFloat(_config["tax_1"] || 0),
                  tax_2: parseFloat(_config["tax_2"] || 0),
                  selected_tax_setting: _config["selected_tax_setting"] || null,
                  taxes: _config["taxes"] || [],
                  tax_setting: _config["tax_setting"] || [],
                  charge_array: _config["charge_array"] || [],
                  cinemas: _config["cinemas"] || [],
                  stock_available: _config["stock_available"] || 0,
                  group_index: index,
                  mer_opt_is_active: _config["mer_opt_is_active"] || "N",
                };
                this.merchandiseObj.merchandiseOptions.push(finalVariantObj);
              }
            });
          } else if (this.merchandiseObj.variantGroupBy == 2) {
            this.MerchandiseVariants.forEach((_config, index) => {
              if (_config.colorArray && _config.colorArray.length) {
                _config.colorArray.forEach((_color) => {
                  let finalVariantObj = {
                    mer_opt_id:
                      _color["mer_opt_id"] || _config["mer_opt_id"] || null,
                    size_id: _config["size_id"] || null,
                    size_name: _config["size_name"] || null,
                    color_id: _color["color_id"] || null,
                    color_name: _color["color_name"] || null,
                    color_code: _color["color_code"] || null,
                    mer_opt_image: _config["mer_opt_image"] || null,
                    has_different_price: _config["has_different_price"] || "N",
                    m_net_amount: parseFloat(
                      _config["m_net_amount"] || 0
                    ).toFixed(4),
                    m_tax_amount: parseFloat(
                      _config["m_tax_amount"] || 0
                    ).toFixed(4),
                    m_gross_amount: parseFloat(
                      _config["m_gross_amount"] || 0
                    ).toFixed(4),
                    tax_setting_id: _config["tax_setting_id"] || null,
                    tax_setting_name: _config["tax_setting_name"] || null,
                    tax_1: parseFloat(_config["tax_1"] || 0),
                    tax_2: parseFloat(_config["tax_2"] || 0),
                    selected_tax_setting:
                      _config["selected_tax_setting"] || null,
                    taxes: _config["taxes"] || [],
                    tax_setting: _config["tax_setting"] || [],
                    charge_array: _config["charge_array"] || [],
                    cinemas: _config["cinemas"] || [],
                    group_index: index,
                    stock_available: _config["stock_available"] || 0,
                    mer_opt_is_active: _config["mer_opt_is_active"] || "N",
                  };
                  this.merchandiseObj.merchandiseOptions.push(finalVariantObj);
                });
              } else {
                let finalVariantObj = {
                  mer_opt_id: _config["mer_opt_id"] || null,
                  color_id: null,
                  color_name: null,
                  color_code: null,
                  size_id: _config["size_id"] || null,
                  size_name: _config["size_name"] || null,
                  mer_opt_image: _config["mer_opt_image"] || null,
                  has_different_price: _config["has_different_price"] || "N",
                  m_net_amount: parseFloat(
                    _config["m_net_amount"] || 0
                  ).toFixed(4),
                  m_tax_amount: parseFloat(
                    _config["m_tax_amount"] || 0
                  ).toFixed(4),
                  m_gross_amount: parseFloat(
                    _config["m_gross_amount"] || 0
                  ).toFixed(4),
                  tax_setting_id: _config["tax_setting_id"] || null,
                  tax_setting_name: _config["tax_setting_name"] || null,
                  tax_1: parseFloat(_config["tax_1"] || 0),
                  tax_2: parseFloat(_config["tax_2"] || 0),
                  selected_tax_setting: _config["selected_tax_setting"] || null,
                  taxes: _config["taxes"] || [],
                  tax_setting: _config["tax_setting"] || [],
                  charge_array: _config["charge_array"] || [],
                  cinemas: _config["cinemas"] || [],
                  group_index: index,
                  stock_available: _config["stock_available"] || 0,
                  mer_opt_is_active: _config["mer_opt_is_active"] || "N",
                };
                this.merchandiseObj.merchandiseOptions.push(finalVariantObj);
              }
            });
          }
        }
      },
      OnFinalSubmit() {
        let checkValid = this.validationCheck();
        if (checkValid) {
          this.createVariantArray();
          let loader = this.$loading.show();
          this.btenable = true;
          if (this.merchandise_id) {
            let payload = {
              merchandise_id: this.merchandise_id,
              merchandise_details: this.merchandiseObj,
            };
            MasterService.UpdateMerchandise(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.$toasted.show(
                    data.message || "Merchandise added successfully"
                  );
                  this.$router.push({
                    path: "/cinema-manager/merchandise",
                  });
                } else {
                  this.$toasted.show(data.message || "Something Went Wrong!");
                }
              })
              .catch((err) => {
                loader.hide();
                console.log("Error:", err);
              })
              .finally(() => {
                loader.hide();
                this.btenable = false;
              });
          } else {
            let payload = {
              merchandise_details: this.merchandiseObj,
            };
            MasterService.AddMerchandise(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.$toasted.show(
                    data.message || "Merchandise added successfully"
                  );
                  this.$router.push({
                    path: "/cinema-manager/merchandise",
                  });
                } else {
                  this.$toasted.show(data.message || "Something Went Wrong!");
                }
              })
              .catch((err) => {
                loader.hide();
                console.log("Error:", err);
              })
              .finally(() => {
                loader.hide();
                this.btenable = false;
              });
          }
        }
      },
    },
  };
</script>
<style>
  .custom-date .btn-clearDate {
    right: 30px !important;
  }
  .customDisabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .new-border {
    border: 2px solid #b1b4b8;
  }
  label {
    color: black !important;
  }
  .internal-border-new {
    border: 1px solid var(--blue);
    /*background-color: #e6e6f8;*/
  }
  .internal-border {
    border: 1px solid var(--blue);
    /*background-color: #e6e6f8;*/
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    margin: 0 15px 15px 15px;
    padding-top: 15px;
    width: 100%;
  }
  .back {
    background-color: #fff;
  }
  .oc_input {
    min-width: 80px !important;
  }
  .oc_input input {
    text-align: center;
    font-weight: 500;
    min-width: 80px !important;
  }
  .oc_inp_group_row {
    gap: 20px;
    margin-bottom: 10px;
  }

  .oc_section_head {
    font-size: 15px;
    margin-bottom: 9px;
  }

  .colorPreview {
    height: 30px;
    width: 35px;
    background: white;
    border-radius: 50%;
  }

  .custom-tag {
    /* display: inline-flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  color: white;
  margin-right: 5px; */

    display: inline-flex;
    align-items: center;
    padding: 2px 10px 2px 10px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 5px;
    color: white;
    margin-right: 5px;
  }
  .custom-tag i {
    margin-left: 8px;
    cursor: pointer;
  }

  .colorPrevier2 {
    height: 20px;
    width: 20px;
    border-radius: 50%;
  }

  .colorSelector {
    background: #dfebffde !important;
    color: black !important;
  }

  .moreSection {
    background: white;
    margin: 10px 0px 10px 0px;
    padding: 5px 0px 5px 0px;
  }

  .borderBox {
    border: 1px solid blue;
    padding: 5px;
    margin: -1px;
    border-radius: 10px;
  }

  .priceCheckBox {
    max-width: 170px;
  }

  .opt_tax_select_pan {
    min-width: 190px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MechandiseComponents/AddMerchandise.vue